import {observer} from 'mobx-react-lite'
import React, {useCallback, useRef} from 'react'
import {Lang} from 'yougile-lang'
import {TextInput} from '@components/common/text-input/text-input'
import {useClickAway} from '@containers/hooks'
import {SprintCtl} from '@extensions/sticker/controllers/sprint-ctl'
import IconDown from '../../../common/icons/icons-common/icon-down.svg'
import {useStickerEditorStore} from '../../sticker-editor-store'
import {MenuDatePicker} from './menu-date-picker'

export const SprintStateEdit = observer(() => {
  const ref = useRef<HTMLInputElement>()
  const [state, store] = useStickerEditorStore()

  const cancel = (): void => {
    store.cancelSprintState()
  }
  const onEnterSave = (): void => {
    store.saveSprintState({openNewEditAfterSave: true})
  }
  const onClickOutside = useCallback(() => store.saveSprintState(), [store])

  useClickAway(ref, onClickOutside)

  const color =
    state.sprintState?.begin && state.sprintState?.end
      ? SprintCtl.color(state.sprintState)
      : undefined

  const iconStyle = {
    color: color?.border
  }

  return (
    <div className="relative py-1 ml-1 w-max">
      <div className="flex flex-col">
        <div className="flex items-center">
          <IconDown style={iconStyle} className="ml-1" />
          <TextInput
            autoFocus
            value={state.sprintStateName}
            onChange={name => store.setSprintStateName(name)}
            onEnter={onEnterSave}
            onEscape={cancel}
            innerRef={ref}
            placeholder={Lang.msg.stickerStatePlaceholder}
            className="border-bg-main-old focus-within:border-bg-main-old"
          />
        </div>
        <MenuDatePicker />
      </div>
    </div>
  )
})
